import { useEffect, useState } from "react";
// import bgProfile from "../../assets/img/defaultcover_profile.jpg";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import ProfileTabData from "../common/ProfileTabData";
import BlogsTab from "../common/BlogsTab";
import ProfileSharedSafariTab from "../common/ProfileSharedSafariTab";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import ShareProfileModal from "../common/ShareProfileModal";
import apiCall from "../Api/api";
import Follower from "../common/Follower";
import Following from "../common/Following";
import { useAuth } from "provider/AuthContext";
import LockTabData from "components/common/LockTabData";
import LockShareData from "components/common/LockShareData";
import LockBlogData from "components/common/LockBlogData";
import dpimg from "assets/img/dpmain.png";
import testCover from "assets/img/test.jpg";
import { useProfileContext } from "provider/ProfileProvider";
import { handleError } from "components/Api/handleError";

const UserProfile = () => {
  const { user_handle } = useParams();
  const location = useLocation();
  const referrer = location.pathname + location.search;
  const { isLoggedIn, userProfile, logout } = useAuth();
  const { userProfileView, profileDispatch } = useProfileContext();
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState();
  const [activeSubTab, setActiveSubTab] = useState("profile");
  const [profileError, setProfileError] = useState(false);
  const [bannerError, setBannerError] = useState(false);

  useEffect(() => {
    const UserProfile = async () => {
      if (userProfileView?.user_handle === user_handle) return;
      try {
        profileDispatch({ type: "SET_PROFILE_DATA_LOADING", payload: true });
        const response = await apiCall({
          url: `user-profile?user_handle=${user_handle}`,
        });

        if (response.status !== 200) {
          throw new Error(`Unexpected status code: ${response.status}`);
        }

        if (response?.status === 200) {
          if (response?.data?.errors) {
            const errors = response?.data.errors;
            profileDispatch({
              type: "SET_PROFILE_DATA_ERROR",
              payload: errors,
            });
            console.error(errors)
          } else {
            const profileData = response?.data;
            profileDispatch({ type: 'SET_PROFILE_DATA', payload: profileData });
          }
        }
      } catch (error) {
        console.error("An error occurred while fetching user profile:", error);
        handleError(error, logout, navigate);
      } finally {
        profileDispatch({ type: "SET_PROFILE_DATA_LOADING", payload: false });
      }
    };

    UserProfile();
  }, [user_handle]);


  const fetchUserProfile = async () => {

    try {
      profileDispatch({ type: "SET_PROFILE_DATA_LOADING", payload: true });
      const response = await apiCall({
        url: `user-profile?user_handle=${user_handle}`,
      });

      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      if (response?.status === 200) {
        if (response?.data?.errors) {
          const errors = response?.data.errors;
          profileDispatch({
            type: "SET_PROFILE_DATA_ERROR",
            payload: errors,
          });
          console.error(errors)
        } else {
          const profileData = response?.data;
          profileDispatch({ type: 'SET_PROFILE_DATA', payload: profileData });
        }
      }
    } catch (error) {
      console.error("An error occurred while fetching user profile:", error);
      handleError(error, logout, navigate);
    } finally {
      profileDispatch({ type: "SET_PROFILE_DATA_LOADING", payload: false });
    }
  };


  const validateFile = (file) => {
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    const maxSize = 250 * 1024; // 250KB

    if (!file) return "No file selected";
    if (!allowedTypes.includes(file.type)) return "Only JPG, JPEG, PNG allowed";
    if (file.size > maxSize) return "File size must be under 250KB";
    return null;
  };



  const handleImageUpload = async (e, type) => {
    const file = e.target.files[0];
    const error = validateFile(file);

    if (error) {
      profileDispatch({ type: "SET_COVER_PHOTO_ERROR", payload: error });
      return;
    }

    try {
      profileDispatch({ type: "SET_COVER_PHOTO_LOADING", payload: true });
      profileDispatch({ type: "SET_COVER_PHOTO_ERROR", payload: "" });

      const formData = new FormData();
      if (type === 'cover') {
        formData.append("cover_image", file);
      } else {
        formData.append("profile_image", file);
      }

      const url = type === 'cover' ? "account/cover-photo" : "account/profile-photo";
      const response = await apiCall({
        url: url,
        method: "POST",
        data: formData,
      });

      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;

      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        const firstKey = Object.keys(apiData.errors)[0];
        return profileDispatch({
          type: "SET_COVER_PHOTO_ERROR",
          payload: apiData.errors[firstKey][0],
        });
      }

      if (apiData?.status === 1) {
        // showSuccessToast(apiData?.message);
        fetchUserProfile(); // refresh profile
      }
    } catch (error) {
      console.error("Cover photo upload error:", error.message);
      handleError(error, logout, navigate);
    } finally {
      profileDispatch({ type: "SET_COVER_PHOTO_LOADING", payload: false });
    }
  };

  const followUsers = () => {

  }

  const unFollowUsers = () => {

  }

  return (
    <>
      <section className="profile-wrapper">
        <Container fluid="lg" className="mb-5">
          <div className="profile_coverbnner mt-md-5 pt-5">
            <Container fluid="lg" className="px-slider2">
              <Row className="justify-content-center px-slider2">
                <Col
                  xxl={10}
                  className="banner-cover position-relative px-slider2"
                >
                  <img
                    src={
                      bannerError || !userProfileView?.cover_display_image
                        ? "/img/defaultcover_walkwild.jpg"
                        : userProfileView.cover_display_image
                    }
                    className="banner-cover"
                    onError={() => setBannerError(true)}
                    alt="Cover "
                  />
                  {(isLoggedIn && user_handle === userProfile?.user_handle) &&
                    <>
                      <label htmlFor="coverImageUpload" className="coverbtns">
                        <i className="fa-solid fa-cloud-arrow-up me-1" />
                        <span>Upload Cover Picture</span>
                      </label>
                      <input
                        type="file"
                        id="coverImageUpload"
                        style={{ display: "none" }}
                        accept=".jpg,.jpeg,.png"
                        onChange={(e) => handleImageUpload(e, "cover")}
                      />
                    </>
                  }
                </Col>
              </Row>
              <Row className="align-items-center justify-content-center">
                <div className="mt-n5" style={{ marginTop: "-5rem" }}>
                  <div className="d-flex align-items-center justify-content-center mb-4">
                    <div className="linear-gradient d-flex align-items-center justify-content-center rounded-circle">
                      <div className="border border-4 border-white d-flex align-items-center justify-content-center profile_img">
                        <img
                          src={
                            profileError || !userProfileView?.profile_display_image
                              ? dpimg
                              : userProfileView?.profile_display_image
                          }
                          alt=""
                          className="w-100 h-100"
                          onError={() => setProfileError(true)}
                        />
                        {(isLoggedIn && user_handle === userProfile?.user_handle) &&
                          <>
                            <label for="profileImageUpload" className="camera-icon">
                              <i className="fas fa-camera"></i>
                            </label>
                            <input
                              type="file"
                              id="profileImageUpload"
                              style={{ display: "none" }}
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, "profile")}
                            />
                          </>}

                      </div>
                    </div>
                  </div>
                  <div className="text-center">
                    <h6 className="fs-3 mb-0 fw-semibold">
                      {userProfileView?.name || "User Name"}
                    </h6>
                  </div>
                  <div className="text-center">
                    <h6 className="mb-0">
                      @{userProfileView?.user_handle || "@username"}
                    </h6>
                  </div>
                  <div className="text-center">
                    <h6 className="mt-3 mb-0">{userProfileView?.user_bio}</h6>
                  </div>
                </div>
                <Col lg={7} style={{ zIndex: "10" }}>
                  <div className="follow_massage d-flex justify-content-center mt-3 gap-3 align-items-center">
                    {(isLoggedIn && user_handle !== userProfile?.user_handle) && <button className="follow_massge rounded-5">
                      <span>Follow</span>
                    </button>
                    }

                    {(isLoggedIn && user_handle === userProfile?.user_handle) && <Link to="/account" className="follow_massge rounded-2">
                      <i className="fa fa-edit"></i> Edit Profile
                    </Link>
                    }
                    <div className="sharerbtn d-md-none">
                      <button
                        value="/profile/default/share-profile"
                        className="follow_massge rounded-2 text-capitalize shareBtn py-2"
                        onClick={() => setModalOpen(true)}
                      >
                        <i className="fa-solid fa-share"></i>
                        <span className="mobileTexthide">Share Profile</span>
                      </button>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="justify-content-center margin_n5">
                <Col xxl={11}>
                  <Row className="justify-content-between align-items-center border-bottom pb-3">
                    <Col md={6}>
                      <div className="d-flex align-items-center flowers-content">
                        <p
                          className="mb-0"
                          style={{ cursor: "pointer" }}
                          onClick={() => { setActiveSubTab("followers"); }}
                        >
                          {userProfileView?.user_followers_count} Followers
                        </p>
                        <p
                          className="mb-0 ms-3"
                          style={{ cursor: "pointer" }}
                          onClick={() => { setActiveSubTab("following"); }}
                        >
                          {userProfileView?.user_followings_count} Following
                        </p>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="sociel_icons float-md-end">

                        {!isLoggedIn ?
                          <ul>
                            <li>
                              <Link
                                to={`/log-in?authclient=google&referrer=${encodeURIComponent(referrer)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="iconSize"
                              >
                                <i className="fa-brands fa-facebook-f"></i>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to={`/log-in?authclient=google&referrer=${encodeURIComponent(referrer)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="iconSize"
                              >
                                <i className="fa-brands fa-youtube"></i>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to={`/log-in?authclient=google&referrer=${encodeURIComponent(referrer)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="iconSize"
                              >
                                <i className="fa-brands fa-instagram"></i>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to={`/log-in?authclient=google&referrer=${encodeURIComponent(referrer)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="iconSize"
                              >
                                <i className="fa-brands fa-x-twitter"></i>
                              </Link>
                            </li>
                            {/* <li>
                              <Link
                                to={`/log-in?authclient=google&referrer=${encodeURIComponent(referrer)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="iconSize"
                              >
                                <i className="fa-solid fa-globe"></i>
                              </Link>
                            </li> */}
                          </ul>
                          :
                          <ul>
                            {userProfileView?.facebook_url && <li>
                              <Link
                                to={userProfileView?.facebook_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="iconSize"
                              >
                                <i className="fa-brands fa-facebook-f"></i>
                              </Link>
                            </li>
                            }
                            {userProfileView?.youtube_url && <li>
                              <Link
                                to={userProfileView?.youtube_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="iconSize"
                              >
                                <i className="fa-brands fa-youtube"></i>
                              </Link>
                            </li>
                            }
                           {userProfileView?.insta_url && <li>
                              <Link
                                to={userProfileView?.insta_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="iconSize"
                              >
                                <i className="fa-brands fa-instagram"></i>
                              </Link>
                            </li>
                            }
                           {userProfileView?.x_url && <li>
                              <Link
                                to={userProfileView?.x_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="iconSize"
                              >
                                <i className="fa-brands fa-x-twitter"></i>
                              </Link>
                            </li>
                            }
                            {/* <li>
                              <Link
                                to={userProfileView?.website_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="iconSize"
                              >
                                <i className="fa-solid fa-globe"></i>
                              </Link>
                            </li> */}
                          </ul>
                        }
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="pt-5 itenary_tabs justify-content-center position-relative">
                <Col xxl={11} className="safartabs position-relative">
                  <Row>
                    <Col md={8}>
                      <Tabs
                        id="myTab"
                        activeKey={activeSubTab}
                        onSelect={(k) => {

                          setActiveSubTab(k);

                        }}
                        className="nav nav-tabs slider_packagemobile d-flex gap-2"
                      >
                        <Tab
                          eventKey="profile"
                          title="Profile"
                          className="nav-item"
                        ></Tab>
                        <Tab
                          eventKey="shared-safari"
                          title="Shared Safaris"
                          className="nav-item"
                        ></Tab>
                        {/* <Tab
                          eventKey="blogs"
                          title="Blogs"
                          className="nav-item"
                        ></Tab> */}
                      </Tabs>
                    </Col>
                    <Col md={4} className="d-md-block d-none">
                      <div className="sharerbtn float-end">
                        <button
                          value="/profile/default/share-profile"
                          className="follow_massge rounded-2 text-capitalize shareBtn mb-2  "
                          variant="primary"
                          onClick={() => setModalOpen(true)}
                        >
                          <i className="fa-solid fa-share"></i>{" "}
                          <span className="mobileTexthide">Share Profile</span>
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
          <ShareProfileModal
            show={modalOpen}
            handleClose={() => setModalOpen(false)}
          />
        </Container>
      </section>
      <section className="">
        <Container fluid="lg">
          <Row className="">
            <>
              <div className="">

                <div>
                  {activeSubTab === "profile" && (
                    <>
                      {isLoggedIn ? (
                        <Row>
                          <Col xxl={11} className="margin_bottomfooter">
                            <Col xl={8}>
                              <ProfileTabData userData={userProfileView} />
                            </Col>
                          </Col>
                        </Row>
                      ) : (
                        <Col xl={12}>
                          <LockTabData />
                        </Col>
                      )}
                    </>
                  )}

                  {activeSubTab === "shared-safari" && (
                    <>
                      {isLoggedIn ? (
                        <Row>
                          <Col xxl={11} className="margin_bottomfooter">
                            <Col lg={12}>
                              <ProfileSharedSafariTab />
                            </Col>
                          </Col>
                        </Row>
                      ) : (
                        <Col xl={12}>
                          <LockShareData />
                        </Col>
                      )}
                    </>)}

                  {activeSubTab === "blogs" && (
                    <>     {isLoggedIn ? (
                      <Row>
                        <Col xxl={11} className="margin_bottomfooter">
                          <Col lg={12}>
                            <BlogsTab />
                          </Col>
                        </Col>
                      </Row>
                    ) : (
                      <Col xl={12}>
                        <LockBlogData />
                      </Col>
                    )}
                    </>
                  )}
                  {activeSubTab === "followers" && isLoggedIn && (
                    <Col xs={12} className="margin_bottomfooter">
                      <Follower />
                    </Col>
                  )}
                  {activeSubTab === "following" && isLoggedIn && (
                    <Col xs={12} className="margin_bottomfooter">
                      <Following />
                    </Col>
                  )}
                </div>










              </div>
            </>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default UserProfile;
